export const countries = [
  "Turkey",
  "Canada",
  "Germany",
  "Ireland",
  "Italy",
  "Japan",
  "Korea, South",
  "Netherlands",
  "Poland",
  "Qatar",
  "Spain",
  "Sweden",
  "Switzerland",
  "United Arab Emirates",
  "United Kingdom",
  "United States",
  "Other European Countries",
  "Other Middle East Countries",
];
